import { Panel, PanelProps } from '@blueprintjs/core';
import * as React from 'react';
import { noop } from 'vet-bones/utils';

import { ModelTypePanel } from 'src/containers/ProjectModelDialog/ModelTypePanel';

export type ModelPanelStackContextValue = {
  stack: Array<Panel<any>>;
  onClose: () => void;
  onOpen: (panel: Panel<any>) => void;
  onReset: () => void;
};

export const ModelPanelStackContext =
  React.createContext<ModelPanelStackContextValue>({
    stack: [],
    onClose: noop,
    onOpen: noop,
    onReset: noop,
  });

export const useModelPanelStack = () => {
  return React.useContext(ModelPanelStackContext);
};

export const useModelPanelStackValue = (): ModelPanelStackContextValue => {
  const [stack, setStack] = React.useState<Array<Panel<any>>>([
    { renderPanel: ModelTypePanel as React.VFC<PanelProps<any>> },
  ]);

  const onOpen = React.useCallback((panel: Panel<any>) => {
    setStack((prev) => [...prev, panel]);
  }, []);
  const onClose = React.useCallback(() => {
    setStack((prev) =>
      prev.length === 1 ? prev : prev.slice(0, prev.length - 1)
    );
  }, []);
  const onReset = React.useCallback(() => {
    setStack((prev) => (prev.length === 1 ? prev : prev.slice(0, 1)));
  }, []);

  return { stack, onOpen, onClose, onReset };
};
